import { render, staticRenderFns } from "./tibi.vue?vue&type=template&id=5a9e5c4d&scoped=true"
import script from "./tibi.vue?vue&type=script&lang=js"
export * from "./tibi.vue?vue&type=script&lang=js"
import style0 from "./tibi.vue?vue&type=style&index=0&id=5a9e5c4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e5c4d",
  null
  
)

export default component.exports